import ApiClient from '~/ApiClient';

import { ReferencedProductType } from './ReferenceProductType';

export interface Result {
	items: ReferencedProductType[];
}

export const findReferencedProductTypes = async (client: ApiClient): Promise<Result> => {
	const request = await client.fetch('ro-price-referencing/max-price/referenced-product-types');
	return request.json();
};
